import * as Styled from './styled';
import { Props } from './types';

function Loading({ visible }: Props) {
  return (
    visible && (
      <Styled.LoadingWrapper>
        <Styled.Ellipse />
        <Styled.Ilustra />
        <Styled.Title>Aguarde enquanto analisamos seu CPF</Styled.Title>
        <Styled.Subtitle>Isso pode demorar alguns segundos.</Styled.Subtitle>
      </Styled.LoadingWrapper>
    )
  );
}

export default Loading;
